import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ProfileMenu from "../../components/ProfileMenu/ProfileMenu";
import FormPhoneInput from "../../components/FormPhoneInput/FormPhoneInput";
import "./UserAddressInfo.css";
import { useSEO } from "../../context/SEOContext";
import { useTranslation } from "react-i18next";
const UserAddressInfo = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("userAddress.meta.title"),
      description: t("userAddress.meta.description"),
      keywords: t("userAddress.meta.keywords"),
      favicon: "/faviconnew.png", // ✅ burada favicon tanımlandı
    });
  }, [setSeo, t]);
  const { id } = useParams();
  const navigate = useNavigate();
  const userId = sessionStorage.getItem("user_id"); // Giriş yapan kullanıcının ID'si
  const [addresses, setAddresses] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [updateData, setUpdateData] = useState({
    title: "",
    name: "",
    surname: "",
    phone: "",
    address1: "",
    address2: "",
    country: "",
    city: "",
    state: "",
  });

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    oldpass: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    country: "",
  });

  const [suggestions, setSuggestions] = useState({ country: [] });

  /*city-state-country-phone */
  const [countryList, setCountryList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const countryRef = useRef(null);
  const cityRef = useRef(null);
  const stateRef = useRef(null);
  const username = "murataktas";
  /*city-state-country-phone */

  useEffect(() => {
    if (userId !== id) {
      Swal.fire({
        icon: "warning",
        title: "Unauthorized Access!",
        text: "You cannot view another user's orders!",
      }).then(() => {
        navigate(`/profile/${userId}`);
      });
    }
  }, [id, userId, navigate]);

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        const url = `${process.env.REACT_APP_API_URL}/user_addresses?user_id=${userId}`;
        const response = await fetch(url);

        // HTTP durum kodunu kontrol et
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const text = await response.text(); // JSON yerine text alıyoruz

        const data = JSON.parse(text); // JSON'a çevirme
        setAddresses(data); // State'e aktar
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error.message || "Something went wrong.",
          confirmButtonColor: "#000",
        });
      }
    };

    fetchAddresses();
  }, [userId]);

  const handleAddressAdd = async () => {
    const title = document.getElementById("adresstitle").value;
    const name = document.getElementById("adressname").value;
    const surname = document.getElementById("adresssurname").value;
    const phone = document.getElementById("adressphone").value;
    const address1 = document.getElementById("adressaddress").value;
    const address2 = document.getElementById("adressaddress2").value;
    // const country = document.getElementById("adresscountry").value;
    // const city = document.getElementById("adresscity").value;
    // const state = document.getElementById("adressstate").value;
    const { country, city, state } = formData;
    // const fullName = `${name} ${surname}`; // fullName'i tek bir alan olarak gönderebiliriz

    const payload = {
      title,
      // name: fullName, // 'name' alanına fullName'i atıyoruz
      name,
      surname,
      phone,
      address1,
      address2,
      country,
      city,
      state,
      user_id: userId, // user_id'yi payload'a ekliyoruz
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/user_addresses`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      // API yanıtını kontrol et ve JSON olarak işle
      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Address has been added.",
          confirmButtonColor: "#000",
        }).then(() => {
          window.location.reload(); // Adres eklendikten sonra sayfayı yenileyelim
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: data.message || "Something went wrong.",
          confirmButtonColor: "#000",
        });
      }
    } catch (error) {
      console.error("Adres eklenirken hata oluştu:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: `Network error or server is unreachable. Details: ${error.message}`,
        confirmButtonColor: "#000",
      });
    }
  };

  const handleUpdateSubmit = async () => {
    const payload = {
      title: updateData.title,
      phone: updateData.phone,
      address1: updateData.address1,
      address2: updateData.address2,
      city: formData.city,
      state: formData.state,
      country: formData.country,
      name: updateData.name, // Full name olarak birleştirilen isim
      surname: updateData.surname, // Soyadı yine ayrı gönderiyoruz
      user_id: userId,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/user_addresses?id=${selectedId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Address updated successfully.",
          confirmButtonColor: "#000",
        }).then(() => {
          setAddresses((prevAddresses) =>
            prevAddresses.map((address) =>
              address.id === selectedId ? { ...address, ...payload } : address
            )
          );
          window.location.reload();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: result.message || "Update failed.",
          confirmButtonColor: "#000",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: `Network error: ${error.message}`,
        confirmButtonColor: "#000",
      });
    }
  };

  const handleDeleteAddress = async (id) => {
    if (!id) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Selected ID is not valid.",
        confirmButtonColor: "#000",
      });
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/user_addresses?id=${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      if (response.ok && result.success) {
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: result.message,
          confirmButtonColor: "#000",
        }).then(() => {
          setAddresses((prevAddresses) =>
            prevAddresses.filter((address) => address.id !== id)
          );
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: result.message || "Failed to delete address.",
          confirmButtonColor: "#000",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: `Network error: ${error.message}`,
        confirmButtonColor: "#000",
      });
    }
  };

  useEffect(() => {
    fetch(`http://api.geonames.org/countryInfoJSON?username=${username}`)
      .then((res) => res.json())
      .then((data) => {
        setCountryList(data.geonames);
      });
  }, []);

  useEffect(() => {
    const selectedCountry = countryList.find(
      (c) => c.countryName === formData.country
    );
    if (selectedCountry) {
      fetch(
        `http://api.geonames.org/searchJSON?country=${selectedCountry.countryCode}&featureClass=P&maxRows=1000&username=${username}`
      )
        .then((res) => res.json())
        .then((data) => {
          setCityList(data.geonames);
        });
    }
  }, [formData.country, countryList]);

  useEffect(() => {
    const selectedCity = cityList.find((c) => c.name === formData.city);
    if (selectedCity?.geonameId) {
      fetch(
        `http://api.geonames.org/childrenJSON?geonameId=${selectedCity.geonameId}&username=${username}`
      )
        .then((res) => res.json())
        .then((data) => {
          setStateList(data.geonames || []);
        });
    }
  }, [formData.city, cityList]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

    if (name === "country") {
      if (value.length > 0) {
        const filtered = countryList
          .filter((c) =>
            c.countryName.toLowerCase().includes(value.toLowerCase())
          )
          .map((c) => c.countryName);
        setSuggestions((prev) => ({ ...prev, country: filtered }));
      } else {
        setSuggestions((prev) => ({ ...prev, country: [] }));
      }
    }

    if (name === "city") {
      if (value.length > 0) {
        const filtered = cityList
          .filter((c) => c.name.toLowerCase().includes(value.toLowerCase()))
          .map((c) => c.name);
        setSuggestions((prev) => ({ ...prev, city: filtered }));
      } else {
        setSuggestions((prev) => ({ ...prev, city: [] }));
      }
    }

    if (name === "state") {
      if (value.length > 0) {
        const filtered = stateList
          .filter((s) => s.name?.toLowerCase().includes(value.toLowerCase()))
          .map((s) => s.name);
        setSuggestions((prev) => ({ ...prev, state: filtered }));
      } else {
        setSuggestions((prev) => ({ ...prev, state: [] }));
      }
    }
  };

  const renderDropdown = (items, onSelect) => {
    return (
      <div
        className="list-group position-absolute w-100"
        style={{ zIndex: 10 }}
      >
        {items.map((item, index) => (
          <button
            type="button"
            key={index}
            className="list-group-item list-group-item-action"
            onClick={() => onSelect(item)}
          >
            {item}
          </button>
        ))}
      </div>
    );
  };

  return (
    <>
      <ProfileMenu userId={userId} />
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-6">
            <h2 className="mb-5 titlecolor">{t("AddressInfoTitle")}</h2>
          </div>
          <div className="col-lg-6 text-end">
            <button
              type="button"
              className="btn profilebtn  fw-14 "
              data-bs-toggle="modal"
              data-bs-target="#addressModel"
            >
              <i className="fa-solid fa-plus fa-sm"></i> {t("AddAddressButton")}
            </button>
          </div>
        </div>
        <div className="row mb-5">
          {addresses.length > 0 ? (
            addresses.map((address) => (
              <div className="col-lg-4" key={address.id}>
                <div className="card mb-3">
                  <div className="card-header pb-0 cardbgtitle">
                    <h6 className="mt-1 text-uppercase">{address.title}</h6>
                  </div>
                  <div className="card-body ">
                    <h5 className="card-title text-uppercase cardtitlecolor">
                      {`${address.name} ${address.surname}`}
                    </h5>
                    <p className="card-text mb-0 mt-3">
                      <i className="fa-solid fa-location-dot me-1 cardtext"></i>{" "}
                      {address.address1} , {address.address2}
                    </p>
                    <p className="card-text">
                      {`${address.country} / ${address.city} / ${address.state} `}
                    </p>
                    <p className="card-text">
                      <i className="fa-solid fa-phone me-1 cardtext"></i>{" "}
                      {address.phone}
                    </p>
                    <div className="row">
                      <div className="col-lg-6 ">
                        <button
                          type="button"
                          className="btn fw-normal fs-11 mt-2 pe-0 px-0 cardtext"
                          onClick={() => {
                            setSelectedId(address.id);
                            handleDeleteAddress(address.id);
                          }}
                        >
                          <i className="fas fa-trash fa-lg"></i>{" "}
                          {t("DeleteButton")}
                        </button>
                      </div>
                      <div className="col-lg-6 text-end">
                        <button
                          type="button"
                          className="btn text-end fw-14 mt-2 profilebtn"
                          data-bs-toggle="modal"
                          data-bs-target="#updateModal"
                          onClick={() => {
                            setSelectedId(address.id);
                            setUpdateData({
                              title: address.title,
                              name: address.name,
                              surname: address.surname,
                              phone: address.phone,
                              address1: address.address1,
                              address2: address.address2,
                              country: address.country,
                              city: address.city,
                              state: address.state,
                            });
                            setFormData((prev) => ({
                              ...prev,
                              country: address.country || "",
                              city: address.city || "", // zaten boş, sorun olmaz
                              state: address.state || "",
                            }));
                          }}
                        >
                          <i className="far fa-edit"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-lg-12 text-center">
              <div className="alert alert-danger py-4" role="alert">
                <h5 className="fw-bold">{t("NoAddressTitle")}</h5>
                <p>{t("NoAddressText")}</p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/*Address Add Modal*/}
      <div
        className="modal fade"
        id="addressModel"
        aria-labelledby="AddressModalLabel"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{t("AddressAddTitle")}</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="form-label">{t("AddressTitleLabel")}</label>
                  <input
                    type="text"
                    className="form-control"
                    id="adresstitle"
                    name="adresstitle"
                    placeholder={t("AddressTitlePlaceholder")}
                  />
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">{t("NameLabel")}</label>
                      <input
                        type="text"
                        className="form-control"
                        id="adressname"
                        name="adressname"
                        placeholder={t("NamePlaceholder")}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">{t("SurnameLabel")}</label>
                      <input
                        type="text"
                        className="form-control"
                        id="adresssurname"
                        name="adresssurname"
                        placeholder={t("SurnamePlaceholder")}
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <FormPhoneInput
                    id="adressphone"
                    name="adressphone"
                    label={t("PhoneLabel")}
                  />
                </div>

                <div className="row">
                  <div className="col-lg-4">
                    {/* Country */}
                    <div className="mb-3 position-relative" ref={countryRef}>
                      <label className="form-label">{t("CountryLabel")}</label>
                      <input
                        type="text"
                        name="country"
                        className="form-control"
                        placeholder={t("CountryPlaceholder")}
                        value={formData.country}
                        onChange={handleChange}
                        autoComplete="off"
                        onFocus={() => {
                          const filtered = countryList
                            .filter((c) =>
                              c.countryName
                                .toLowerCase()
                                .includes(formData.country.toLowerCase())
                            )
                            .map((c) => c.countryName);
                          setSuggestions((prev) => ({
                            ...prev,
                            country: filtered,
                          }));
                        }}
                      />
                      {formData.country.length > 0 &&
                        suggestions.country.length > 0 &&
                        renderDropdown(suggestions.country, (item) => {
                          setFormData((prev) => ({
                            ...prev,
                            country: item,
                            city: "",
                            state: "",
                          }));
                          setSuggestions((prev) => ({ ...prev, country: [] }));
                        })}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    {/* City */}
                    <div className="mb-3 position-relative" ref={cityRef}>
                      <label className="form-label">{t("CityLabel")}</label>
                      <input
                        type="text"
                        name="city"
                        className="form-control"
                        value={formData.city}
                        placeholder={t("CityPlaceholder")}
                        onChange={handleChange}
                        autoComplete="off"
                        onFocus={() => {
                          const filtered = cityList
                            .filter((c) =>
                              c.name
                                .toLowerCase()
                                .includes(formData.city.toLowerCase())
                            )
                            .map((c) => c.name);
                          setSuggestions((prev) => ({
                            ...prev,
                            city: filtered,
                          }));
                        }}
                      />
                      {formData.city?.length > 0 &&
                        suggestions.city?.length > 0 &&
                        renderDropdown(suggestions.city, (item) => {
                          setFormData((prev) => ({
                            ...prev,
                            city: item,
                            state: "",
                          }));
                          setSuggestions((prev) => ({ ...prev, city: [] }));
                        })}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    {/* State */}
                    <div className="mb-3 position-relative" ref={stateRef}>
                      <label className="form-label">{t("StateLabel")}</label>
                      <input
                        type="text"
                        name="state"
                        className="form-control"
                        placeholder={t("StatePlaceholder")}
                        value={formData.state}
                        onChange={handleChange}
                        autoComplete="off"
                        onFocus={() => {
                          const filtered = stateList
                            .filter((s) =>
                              s.name
                                ?.toLowerCase()
                                .includes(formData.state.toLowerCase())
                            )
                            .map((s) => s.name);
                          setSuggestions((prev) => ({
                            ...prev,
                            state: filtered,
                          }));
                        }}
                      />
                      {formData.state?.length > 0 &&
                        suggestions.state?.length > 0 &&
                        renderDropdown(suggestions.state, (item) => {
                          setFormData((prev) => ({ ...prev, state: item }));
                          setSuggestions((prev) => ({ ...prev, state: [] }));
                        })}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">{t("AddressLabel")}</label>
                      <input
                        type="text"
                        className="form-control"
                        id="adressaddress"
                        name="adressaddress"
                        placeholder={t("AddressPlaceholder")}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">{t("Address2Label")}</label>
                      <input
                        type="text"
                        className="form-control"
                        id="adressaddress2"
                        name="adressaddress2"
                        placeholder={t("Address2Placeholder")}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-dark"
                onClick={handleAddressAdd}
              >
                <i className="fa-solid fa-plus"></i> {t("AddressAddButton")}
              </button>
              <button
                type="button"
                className="btn btn-outline-dark"
                data-bs-dismiss="modal"
              >
                {t("CloseButton")}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/*Address Update Modal */}
      <div
        className="modal fade"
        id="updateModal"
        aria-labelledby="UpdateModalLabel"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{t("AddressUpdateTitle")}</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="form-label">{t("AddressTitleLabel")}</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Title"
                    value={updateData.title}
                    onChange={(e) =>
                      setUpdateData({ ...updateData, title: e.target.value })
                    }
                  />
                </div>
                <div className="row">
                  <div className="col-lg-6 mb-3">
                    <label className="form-label">{t("UpdateNameLabel")}</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("UpdateNamePlaceholder")}
                      value={updateData.name}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, name: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <label className="form-label">
                      {t("UpdateSurnameLabel")}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("UpdateSurnamePlaceholder")}
                      value={updateData.surname}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          surname: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <FormPhoneInput
                    value={updateData.phone}
                    onChange={(phone) =>
                      setUpdateData({ ...updateData, phone })
                    } // Güncellenmiş numarayı alıp set ediyoruz
                    label={t("PhoneLabel")}
                  />
                </div>

                <div className="row">
                  <div className="col-lg-6 mb-3">
                    <label className="form-label">
                      {t("UpdateAddress1Label")}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("UpdateAddress1Placeholder")}
                      value={updateData.address1}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          address1: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <label className="form-label">
                      {t("UpdateAddress2Label")}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("UpdateAddress2Placeholder")}
                      value={updateData.address2}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          address2: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-4">
                    {/* Country */}
                    <div className="mb-3 position-relative" ref={countryRef}>
                      <label className="form-label">
                        {t("UpdateCountryLabel")}
                      </label>
                      <input
                        type="text"
                        name="country"
                        className="form-control"
                        placeholder={t("UpdateCountryPlaceholder")}
                        value={formData.country}
                        onChange={handleChange}
                        autoComplete="off"
                        onFocus={() => {
                          const filtered = countryList
                            .filter((c) =>
                              c.countryName
                                .toLowerCase()
                                .includes(formData.country.toLowerCase())
                            )
                            .map((c) => c.countryName);
                          setSuggestions((prev) => ({
                            ...prev,
                            country: filtered,
                          }));
                        }}
                      />
                      {formData.country.length > 0 &&
                        suggestions.country.length > 0 &&
                        renderDropdown(suggestions.country, (item) => {
                          setFormData((prev) => ({
                            ...prev,
                            country: item,
                            city: "",
                            state: "",
                          }));
                          setSuggestions((prev) => ({ ...prev, country: [] }));
                        })}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    {/* City */}
                    <div className="mb-3 position-relative" ref={cityRef}>
                      <label className="form-label">
                        {t("UpdateCityLabel")}
                      </label>
                      <input
                        type="text"
                        name="city"
                        className="form-control"
                        placeholder={t("UpdateCityPlaceholder")}
                        value={formData.city}
                        onChange={handleChange}
                        autoComplete="off"
                        onFocus={() => {
                          const filtered = cityList
                            .filter((c) =>
                              c.name
                                .toLowerCase()
                                .includes(formData.city.toLowerCase())
                            )
                            .map((c) => c.name);
                          setSuggestions((prev) => ({
                            ...prev,
                            city: filtered,
                          }));
                        }}
                      />
                      {formData.city?.length > 0 &&
                        suggestions.city?.length > 0 &&
                        renderDropdown(suggestions.city, (item) => {
                          setFormData((prev) => ({
                            ...prev,
                            city: item,
                            state: "",
                          }));
                          setSuggestions((prev) => ({ ...prev, city: [] }));
                        })}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    {/* State */}
                    <div className="mb-3 position-relative" ref={stateRef}>
                      <label className="form-label">
                        {t("UpdateStateLabel")}
                      </label>
                      <input
                        type="text"
                        name="state"
                        className="form-control"
                        placeholder={t("UpdateStatePlaceholder")}
                        value={formData.state}
                        onChange={handleChange}
                        autoComplete="off"
                        onFocus={() => {
                          const filtered = stateList
                            .filter((s) =>
                              s.name
                                ?.toLowerCase()
                                .includes(formData.state.toLowerCase())
                            )
                            .map((s) => s.name);
                          setSuggestions((prev) => ({
                            ...prev,
                            state: filtered,
                          }));
                        }}
                      />
                      {formData.state?.length > 0 &&
                        suggestions.state?.length > 0 &&
                        renderDropdown(suggestions.state, (item) => {
                          setFormData((prev) => ({ ...prev, state: item }));
                          setSuggestions((prev) => ({ ...prev, state: [] }));
                        })}
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-dark"
                onClick={handleUpdateSubmit}
              >
                {t("SaveChangesButton")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserAddressInfo;
